import React, {Component} from "react";
import FormatMessage from "../messages/FormatMessage";
import {withRouter} from 'react-router-dom';

class EQMobileMenu extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="SiteSidebar in" style={{display: "block"}}>
                <div className="SiteSidebar-container">
                    <div className="SiteSidebar-nav">
                        <div className="GridLayout SiteSidebar-navGridLayout">
                            <div className="GridLayoutCell SiteSidebar-navGridLayoutCell">
                                <a onClick={() => window.location.href = "/application-center/applicationcenter.do"}
                                   className="Button  SiteSidebar-button">
                                    <div className="FixedLayout Button-layout">
                                        <div className="FixedLayoutAside Button-leftAside">
                                            <span className="Icon Icon-signIn Button-icon"></span>
                                        </div>
                                        <div className="FixedLayoutMain Button-label">
                                            <FormatMessage id="application.signin.link"/>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="GridLayoutCell SiteSidebar-navGridLayoutCell">
                                <a className="Button  SiteSidebar-button"
                                   onClick={() => this.props.handleMobileMenu(false)}>
                                    <div className="FixedLayout Button-layout">
                                        <div className="FixedLayoutAside Button-leftAside">
                                            <span className="Icon Button-icon Icon-circleCloseHollow"/>
                                        </div>
                                        <div className="FixedLayoutMain Button-label"><FormatMessage
                                            id="control.button.close"/></div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(EQMobileMenu)
